import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import * as React from 'react';

var targetCaptured = function targetCaptured(element, target) {
  return element.contains(target);
};

var useHandleCapturedEventsRef = function useHandleCapturedEventsRef(initialRefValue, eventFnMap) {
  var eventWrapperRef = React.useRef(initialRefValue);
  var eventConfigs = Object.keys(eventFnMap).map(function (eventFnMapKey) {
    var eventFnArray = eventFnMap[eventFnMapKey] || [];
    return eventFnArray.map(function (eventFn) {
      var downHandler = function downHandler(event) {
        if (eventWrapperRef.current && targetCaptured(eventWrapperRef.current, event.target)) {
          eventFn(event);
        }
      };

      return {
        eventName: eventFnMapKey,
        downHandler: downHandler
      };
    });
  }).reduce(function (eventFnMapArrays, nextEventFnMapArray) {
    return [].concat(_toConsumableArray(eventFnMapArrays), _toConsumableArray(nextEventFnMapArray));
  }, []);
  React.useEffect(function () {
    eventConfigs.forEach(function (eventConfig) {
      return window.addEventListener(eventConfig.eventName, eventConfig.downHandler);
    });
    return function () {
      eventConfigs.forEach(function (eventConfig) {
        return window.removeEventListener(eventConfig.eventName, eventConfig.downHandler);
      });
    };
  });
  return eventWrapperRef;
};

export { targetCaptured, useHandleCapturedEventsRef };